import { default as en_us } from './en_us'

export class Language {
  public static strings = en_us

  static map = {
    en_us: en_us
  }

  /**
   * Load strings for language and culture
   *
   * @param lang Language to load (e.g. `en_us`)
   * @returns Loaded language strings
   */
  static of(lang: string): typeof Language.strings {
    return Language.map[lang as keyof (typeof Language)['map']]
  }
}
